import local from "api/local";
import ApolloClient from "apollo-boost";
import { ErrorResponse } from "apollo-link-error";
import Text from "components/common/Text/Text";
import { IAccess } from "components/Gates/ActivationGate";
import { getIdentity } from "init/tracking";
import * as React from "react";
import { ApolloProvider } from "react-apollo";
import styled from "styled-components";
import rollBar from "utils/rollbar";

const Annotation = styled(Text)`
  position: fixed;
  bottom: 0px;
  right: 0px;
  margin: 0px;
  background-color: rgba(255, 255, 255, 0.6);
  font-size: 25px;
`;

export const AllowedApiErrors: string[] = [
  "7 PERMISSION_DENIED: Invalid phone number/pin combination",
  "5 NOT_FOUND: This promo code is not valid.",
  "8 RESOURCE_EXHAUSTED: You have already used this promo code."
];

export interface IProps {
  apiUrl: string;
  children: any;
  access: IAccess;
}

export interface IState {
  showingDetails?: boolean;
  error?: string;
  errorTimeOut?: number;
}

class ApiGate extends React.Component<IProps, IState> {
  private client: ApolloClient<any>;
  constructor(props: IProps) {
    super(props);
    this.state = {
      showingDetails: false
    };
    this.client = new ApolloClient({
      uri: props.apiUrl,
      request: async (operation: any) => {
        return operation.setContext({
          headers: {
            authorization: `Bearer ${await props.access.fetchAccessToken()}`
          }
        });
      },
      onError: ({ graphQLErrors, networkError }: ErrorResponse) => {
        if (networkError) {
          const { result } = networkError as any;
          if (result) {
            this.printError(
              `network Error with status: ${result.status} and message ${result.message}`
            );
          } else {
            this.printError(networkError.message);
          }
        } else if (graphQLErrors && graphQLErrors.length > 0) {
          if (!AllowedApiErrors.includes(graphQLErrors[0].message)) {
            this.printError(graphQLErrors[0].message);
          }
        }
      },
      clientState: local
    });
  }

  public componentDidMount() {
    this.clearError();
    window.addEventListener("error", this.handleWindowError);
  }

  public componentWillUnmount() {
    if (this.state.errorTimeOut) {
      window.clearInterval(this.state.errorTimeOut);
    }
    window.removeEventListener("error", this.handleWindowError);
  }

  public render() {
    return (
      <>
        <ApolloProvider client={this.client}>
          {this.props.children}
        </ApolloProvider>
        {this.state.error &&
          (this.state.showingDetails ? (
            <Annotation onClick={this.clearError}>
              {this.state.error}
            </Annotation>
          ) : (
            this.state.error && (
              <Annotation onClick={this.showDetails}>API error</Annotation>
            )
          ))}
      </>
    );
  }

  private handleWindowError = (error: ErrorEvent) => {
    this.printError(error.message);
  };

  private printError = (error: string) => {
    if (error) {
      getIdentity().then(
        identity => console.error("API Error", error, identity)
        // rollBar.error(`${identity} - Api Error ${error}`)
      );
    }

    this.setState(state => ({
      showingDetails: false,
      error,
      errorTimeOut: this.computeErrorTimeOut(error, state.errorTimeOut)
    }));
  };

  private clearError = () =>
    this.setState(state => ({
      showingDetails: false,
      error: undefined,
      errorTimeOut: this.computeErrorTimeOut(undefined, state.errorTimeOut)
    }));

  private showDetails = () => {
    this.setState(state => ({
      showingDetails: true,
      errorTimeOut: this.computeErrorTimeOut(state.error, state.errorTimeOut)
    }));
  };

  private computeErrorTimeOut = (
    error?: string,
    oldErrorTimeOut?: number
  ): number | undefined => {
    let newErrorTimeout;
    if (error) {
      if (oldErrorTimeOut) {
        window.clearInterval(oldErrorTimeOut);
      }
      newErrorTimeout = window.setInterval(() => this.clearError(), 15000);
    } else if (oldErrorTimeOut) {
      window.clearInterval(oldErrorTimeOut);
      newErrorTimeout = undefined;
    }

    return newErrorTimeout;
  };
}

export default ApiGate;



// WEBPACK FOOTER //
// ./src/components/Gates/ApiGate.tsx